<template>
  <Legacy
    view="edi"
    action="bulktrack"
  />
</template>

<script>
import Legacy from '@/components/Application/Legacy'

export default {
  components: {
    Legacy
  },
  data () {
    return {
      title: 'Tracking',
      breadcrumb: {
        name: 'Tracking',
        route: { name: 'freight-tracking' }
      }
    }
  }
}
</script>
